import { React, PT, withRouter, NavLink, connect, fetchApi } from '@gasbuddy/react';
import { Menu, Grid, Input, Popup, List } from 'semantic-ui-react';
import Styles from './styles.css';
import { hasAnyGroup } from '../../../client/lib/auth';
import { Action } from '../../reducers/actions';
import { Role, RoleAction, ActionGroups } from '../../roles';
import { Auth } from '../auth/Auth';

class BaseNavComponent extends React.Component {
  state = {}

  setQuickSearch = ({ target: { value } }) => {
    this.setState({ qs: value });
  }

  keypress = (e) => {
    const { qs } = this.state;
    const { history } = this.props;
    if (e.key === 'Enter') {
      const nqs = Number(qs);
      if (Number.isSafeInteger(nqs)) {
        history.push(`/identity/users/${nqs}`);
      }
      if (/^([a-zA-Z0-9_\-.+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(qs)) {
        history.push(`/identity/users/${encodeURIComponent(qs)}`);
      }
      if (qs.startsWith('gb:') || qs.startsWith('card:') || qs.startsWith('e:') || qs.startsWith('rs:')) {
        history.push(`/identity/users/${encodeURIComponent(qs.replace(/^gb:/, 'gb_legacy:'))}`);
      }
      if (qs.startsWith('f:')) {
        fetchApi({
          url: '/payments/fulfillments/lookup',
          body: { fulfillmentId: qs.substring(2).trim() },
        }).then(({ body }) => history.push(`/payments/instrument-map/${body.instrument_account_map_id}`));
      }
      if (qs.startsWith('m:')) {
        history.push(`/identity/users/member_name:${encodeURIComponent(qs.substring(2).trim())}`);
      }
      if (qs.startsWith('tt:')) {
        history.push(`/identity/users/trip_taker:${encodeURIComponent(qs.substring(3).trim())}`);
      }
      if (qs.startsWith('g:')) {
        history.push(`/identity/users/guid:${encodeURIComponent(qs.substring(2).trim())}`);
      }
      if (qs.startsWith('p:')) {
        const split = qs.split(':');
        history.push(`/identity/users/partner:${encodeURIComponent(split[1])}:${encodeURIComponent(split[2])}`);
      }
      if (qs.startsWith('tx:')) {
        history.push(`/payments/transaction/${qs.substring(3).trim()}`);
      }
      if (qs.startsWith('sm:')) {
        history.push(`/payments/location/${qs.substring(3).trim()}`);
      }
      if (qs.startsWith('gu:')) {
        history.push(`/identity/users/get_upside:${encodeURIComponent(qs.substring(3).trim())}`);
      }
      if (qs.startsWith('etx:')) {
        const split = qs.substring(4).split('|');
        history.push(`/payments/transaction/external/${split[0]}/${split[1]}`);
      }
      if (qs.startsWith('stripe:')) {
        history.push(`/identity/users/stripe:${encodeURIComponent(qs.substring(7).trim())}`);
      }
    }
  }

  render() {
    const { children, groups, dispatch } = this.props;
    const ifGroup = (...args) => hasAnyGroup(groups, 'admin.superuser', ...args);

    return (
      <Grid className={Styles.nav} padded columns="equal">
        <Grid.Column as={Menu} className={Styles.sidebar} width={3} vertical inverted borderless>
          <Menu.Item>
            <Popup
              wide
              on="focus"
              trigger={(
                <Input
                  onKeyPress={this.keypress}
                  onChange={this.setQuickSearch}
                  icon="search"
                  placeholder="Quick Search"
                  size="tiny"
                />
              )}
              header="What You Can Do"
              content={(
                <List>
                  <List.Item>
                    <i>1234</i>
                    {' '}
                    - View account by identity id
                  </List.Item>
                  <List.Item>
                    <i>e:VAONsTgzH</i>
                    {' '}
                    - View account by encrypted id
                  </List.Item>
                  <List.Item>
                    <i>foo@bar.it</i>
                    {' '}
                    - View account by email
                  </List.Item>
                  <List.Item>
                    <i>m:djmaxm</i>
                    {' '}
                    - View account by member name
                  </List.Item>
                  <List.Item>
                    <i>g:GUID</i>
                    {' '}
                    - View account by GUID
                    {' '}
                  </List.Item>
                  <List.Item>
                    <i>tt:GUID</i>
                    {' '}
                    - View account by trip taker GUID
                    {' '}
                  </List.Item>
                  <List.Item>
                    <i>gb:1234</i>
                    {' '}
                    - View account by legacy id
                  </List.Item>
                  <List.Item>
                    <i>card:ABXF</i>
                    {' '}
                    - View account by Wex coded name
                  </List.Item>
                  <List.Item>
                    <i>rs:1234</i>
                    {' '}
                    - View account by Roadside ID
                  </List.Item>
                  <List.Item>
                    <i>p:partner_name:dff5f</i>
                    {' '}
                    - View account by GasBack partner ID
                  </List.Item>
                  <List.Item>
                    <i>tx:1234</i>
                    {' '}
                    - View transaction by GasBuddy id
                  </List.Item>
                  <List.Item>
                    <i>tx:11b2d2</i>
                    {' '}
                    - View transaction
                                        by encrypted GasBuddy id
                  </List.Item>
                  <List.Item>
                    <i>etx:counterparty|1234</i>
                    - View transaction by external transaction id
                  </List.Item>
                  <List.Item>
                    <i>f:1234</i>
                    {' '}
                    - Lookup Perfect Plastic Mail id
                  </List.Item>
                  <List.Item>
                    <i>sm:1234</i>
                    - View location data by Station Master Id
                  </List.Item>
                  <List.Item>
                    <i>gu:guid</i>
                    - View account by Get Upside ID
                  </List.Item>
                  <List.Item>
                    <i>stripe:customer_id</i>
                    - View account by Stripe Customer ID
                  </List.Item>
                </List>
              )}
            />
          </Menu.Item>

          {ifGroup('admin.identity')
            && (
              <Menu.Item>
                <Menu.Header>Identity</Menu.Header>
                <Menu.Menu>
                  <Auth forActions={RoleAction.ViewAndSearchUsers} hideUnauthorized>
                    <Menu.Item name="users" as={NavLink} to="/identity/users" />
                  </Auth>
                  <Auth forActions={ActionGroups.ViewAndSearchUsers} hideUnauthorized>
                    <Menu.Item name="Bulk Lookup" as={NavLink} to="/identity/lookup" />
                  </Auth>
                  <Auth forActions={RoleAction.ViewAndSearchGroups} hideUnauthorized>
                    <Menu.Item name="groups" as={NavLink} to="/identity/groups" />
                  </Auth>
                  <Auth forActions={ActionGroups.ViewAdminAccessPage} hideUnauthorized>
                    <Menu.Item name="admin access" as={NavLink} to="/identity/admin" />
                  </Auth>
                </Menu.Menu>
              </Menu.Item>
            )
          }

          {ifGroup(Role.Payment)
            && (
            <Menu.Item>
              <Menu.Header>Payments</Menu.Header>
              <Menu.Menu>
                {ifGroup(Role.PaymentView)
                  && <Menu.Item name="transaction search" as={NavLink} to="/payments/transactions/search" />
                }
                {ifGroup(Role.PaymentView)
                  && <Menu.Item name="bank search" as={NavLink} to="/payments/instruments/search" />
                }
                {ifGroup(Role.PaymentView)
                  && <Menu.Item name="daily metrics" as={NavLink} to="/payments/daily" />
                }
                {ifGroup(Role.PaymentView)
                  && <Menu.Item name="batch metrics" as={NavLink} to="/payments/batch" />
                }
                {ifGroup(Role.PaymentView)
                  && <Menu.Item name="monthly report" as={NavLink} to="/payments/monthly" />
                }
                {ifGroup(Role.PaymentView)
                  && <Menu.Item name="coupons" as={NavLink} to="/payments/coupons" />
                }
                {ifGroup(Role.Dwolla)
                  && <Menu.Item name="dwolla" as={NavLink} to="/payments/dwolla" />
                }
                {ifGroup(Role.PaymentView)
                  && <Menu.Item name="unbalanced" as={NavLink} to="/payments/unbalanced-transactions" />
                }
                {ifGroup(Role.PaymentView)
                  && <Menu.Item name="unprocessable billing" as={NavLink} to="/payments/unprocessable-billing" />
                }
                {ifGroup(Role.PaymentView)
                  && <Menu.Item name="blocked cards" as={NavLink} to="/payments/accounts/inactive" />
                }
                {ifGroup(Role.PaymentView)
                  && <Menu.Item name="cards" as={NavLink} to="/payments/cards" />
                }
                {ifGroup(Role.RecordReturnedCards)
                  && <Menu.Item name="returned cards" as={NavLink} to="/payments/return-to-sender" />
                }
                {ifGroup(Role.PaymentReconciliation)
                  && <Menu.Item name="wex reconciliation" as={NavLink} to="/payments/wex" />
                }
                {ifGroup(Role.PaymentView)
                  && <Menu.Item name="wex station matching" as={NavLink} to="/payments/wex-matcher" />
                }
                {ifGroup(Role.PaymentRunBilling)
                  && <Menu.Item name="bulk billing" as={NavLink} to="/payments/transactions/rerun" />}
                {ifGroup(Role.PaymentRunBilling)
                  && <Menu.Item name="bulk account fraud" as={NavLink} to="/payments/instruments/rerun" />}
              </Menu.Menu>
            </Menu.Item>
            )
          }
          {ifGroup(Role.GasBack)
            && (
            <Menu.Item>
              <Menu.Header>GasBack</Menu.Header>
              <Menu.Menu>
                {ifGroup(Role.GasBackCampaigns)
                  && <Menu.Item name="Offers" as={NavLink} to="/loyalty/offers" />
                }
                {ifGroup(Role.GasBackCampaigns)
                  && <Menu.Item name="Card Linked Offers" as={NavLink} to="/loyalty/clo" />
                }
                {ifGroup(Role.GasBackCampaigns)
                  && <Menu.Item name="Button Merchants" as={NavLink} to="/loyalty/button" />
                }
                {ifGroup(Role.GasBackCampaigns)
                  && <Menu.Item name="Categories" as={NavLink} to="/loyalty/categories" />
                }
                {ifGroup(Role.CreateGasBackCodes)
                  && <Menu.Item name="Create Codes" as={NavLink} to="/payments/gasback/codes" />
                }
                {ifGroup(Role.ManualGasBackSync)
                  && <Menu.Item name="Post Redemptions" as={NavLink} to="/payments/gasback/redemptions" />
                }
              </Menu.Menu>
            </Menu.Item>
            )
          }
          {ifGroup('admin')
            && (
              <Menu.Item>
                <Menu.Header>POI</Menu.Header>
                <Menu.Menu>
                  <Menu.Item name="poi management" as={NavLink} to="/poi" />
                  <Menu.Item name="brand management" as={NavLink} to="/poi/brands" />
                </Menu.Menu>
              </Menu.Item>
            )
          }
          {ifGroup('admin.system')
            && (
              <Menu.Item>
                <Menu.Header>System</Menu.Header>
                <Menu.Menu>
                  <Menu.Item name="log search" as={NavLink} to="/system/logs" />
                  <Menu.Item name="live logs" as={NavLink} to="/system/live-logs" />
                  <Menu.Item name="deployments" as={NavLink} to="/system/deployments" />
                  {ifGroup(Role.SystemFeaturesView, Role.SystemFeaturesModify)
                    && <Menu.Item name="features" as={NavLink} to="/system/features" />
                  }
                  {ifGroup(Role.Queues)
                    && <Menu.Item name="queues" as={NavLink} to="/system/queues" />
                  }
                  {ifGroup(Role.SystemApi)
                    && <Menu.Item name="service calls" as={NavLink} to="/system/api" />
                  }
                  {ifGroup(Role.TestNotifications)
                    && <Menu.Item name="notifications" as={NavLink} to="/system/notifications" />
                  }
                </Menu.Menu>
              </Menu.Item>
            )
          }

          <Menu.Item name="reports" as={NavLink} to="/reports" />

          {
            process.env.NODE_ENV !== 'production'
            && <Menu.Item name="DEV TOOLS" as={NavLink} to="/devtools" />
          }

          <Menu.Item
            name="logout"
            onClick={
              () => {
                dispatch({
                  type: Action.Auth.LogoutRequested,
                  meta: { apiAction: true },
                  payload: { url: '/auth/logout' },
                });
              }
            }
          />
        </Grid.Column>

        <Grid.Column>
          {children}
        </Grid.Column>
      </Grid>
    );
  }
}

BaseNavComponent.propTypes = {
  children: PT.element,
  groups: PT.arrayOf(PT.arrayOf(PT.string)),
  dispatch: PT.func.isRequired,
  history: PT.shape({ push: PT.func.isRequired }).isRequired,
};

BaseNavComponent.defaultProps = {
  children: null,
  groups: [],
};

export const Nav = connect(({ auth }) => ({ groups: auth.groups }))(withRouter(BaseNavComponent));
